export const loadJS = (src: string) => {
  Log.app.warn("loading the script " + src);
  return new Promise((resolve, reject) => {
    if (document.querySelector(`head > script[src="${src}"]`) !== null) {
      // test if script is already loaded
      return resolve(undefined);
    }
    const script = document.createElement("script");
    script.src = src;
    script.async = true;
    document.head.appendChild(script);
    script.onload = resolve;
    script.onerror = e => {
      Log.app.error(e);
      reject();
    };
  });
};
